import React from "react";

import { ProductMarketplaceCategory } from "custom-types/Product";

import ChevronIcon from "components/Icons/ChevronIcon";

interface BreadcrumbProps {
  text: string;
  href: string;
  chevron?: boolean;
  position: number;
}

const Breadcrumb = ({
  chevron = true,
  href,
  text,
  position,
}: BreadcrumbProps) => {
  return (
    <>
      <li
        className="breadcrumb-item flex text-xs font-bold items-center whitespace-nowrap"
        itemScope
        itemType="http://schema.org/ListItem"
        itemProp="itemListElement"
      >
        <a className="p-0 underline cursor-pointer" href={href} itemProp="item">
          <span itemProp="name">{text}</span>
        </a>
        <meta content={position.toString()} itemProp="position" />
        {chevron && <ChevronIcon height="12" width="12" direction="right" />}
      </li>
      <style jsx>{`
        .breadcrumb-item:last-child a {
          text-decoration: none;
        }
      `}</style>
    </>
  );
};

interface ProductBreadcrumbsProps {
  category?: ProductMarketplaceCategory;
  subcategory?: ProductMarketplaceCategory;
}

export const ProductBreadcrumbs = ({
  category,
  subcategory,
}: ProductBreadcrumbsProps) => {
  return (
    <ol
      className="flex mt-md"
      itemScope
      itemType="http://schema.org/BreadcrumbList"
    >
      <Breadcrumb href="/" text="Home" position={1} />
      <Breadcrumb
        href="/products"
        text="Shop"
        chevron={!!category}
        position={2}
      />
      {category && (
        <Breadcrumb
          href={`/products/${category.slug}`}
          text={category.name}
          chevron={!!subcategory}
          position={3}
        />
      )}
      {category && subcategory && (
        <Breadcrumb
          href={`/products/${category.slug}/${subcategory.slug}`}
          text={subcategory.name}
          chevron={false}
          position={3}
        />
      )}
    </ol>
  );
};
